import React from 'react';
import { Section } from './ui/Section';
import { Card } from './ui/Card';
import { Linkedin, Instagram } from 'lucide-react';
export function Speaker() {
  return <Section className="bg-[#0A0F2A]" data-id="element-414">
      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-415">
        <div className="order-2 md:order-1" data-id="element-416">
          <h2 className="text-3xl md:text-5xl font-bold mb-8" data-id="element-417">
            Хто проводить навчання?
          </h2>
          <div className="space-y-6 mb-8" data-id="element-418">
            <div data-id="element-419">
              <h3 className="text-2xl font-bold text-white" data-id="element-420">Нікіта Шпірт</h3>
              <p className="text-blue-400 font-medium" data-id="element-421">
                Founder & CEO ARMAR Solutions
              </p>
            </div>
            <ul className="space-y-3 text-gray-300" data-id="element-422">
              {['Підприємець, стратег, автор методології', '8+ років у бізнес-зростанні та управлінні', '1000+ стратегічних консультацій', '50+ запусків проєктів', 'Читає лекції у КНУ, КПІ, ЛНУ ім. Івана Франка', 'Автор методології Leader Mindset', 'Партнер Мінцифри'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-423">
                  <div className="w-1.5 h-1.5 rounded-full bg-blue-400 mt-2" data-id="element-424"></div>
                  <span data-id="element-425">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="flex gap-4" data-id="element-426">
            <a href="https://www.linkedin.com/in/nikita-shpirt-a47789239/" target="_blank" rel="noreferrer" className="p-3 bg-white/5 rounded-full hover:bg-blue-600 transition-colors" data-id="element-427">
              <Linkedin className="w-6 h-6" data-id="element-428" />
            </a>
            <a href="https://www.instagram.com/nikitashp?igsh=YjFwZjRreDFkZzZ6" target="_blank" rel="noreferrer" className="p-3 bg-white/5 rounded-full hover:bg-pink-600 transition-colors" data-id="element-429">
              <Instagram className="w-6 h-6" data-id="element-430" />
            </a>
          </div>
        </div>
        <div className="order-1 md:order-2" data-id="element-431">
          <Card className="aspect-[4/5] relative overflow-hidden !p-0 border-none" data-id="element-432">
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0F2A] via-transparent to-transparent z-10" data-id="element-433"></div>
            <img src="https://cdn.magicpatterns.com/uploads/64xmdDJWUq21HvTwBmaFMq/Frame_3.jpg" alt="Нікіта Шпірт" className="w-full h-full object-cover" data-id="element-434" />
          </Card>
        </div>
      </div>
    </Section>;
}